export default "__VITE_ASSET__d67083c5__"